<template>
    <div v-if="layout === 'horizontal'">
        <div class="form-group row justify-content-center mb-0">
            <label :id="id" v-if="title" class="col-md-2 col-form-label text-md-right align-self-md-center mb-0 mt-2" :for="id">
                {{ title }}
            </label>
            <div class="col-md-4">
                <div class="text-right">
                    <button
                        type="button"
                        v-for="(item, i) of langs"
                        :key="i"
                        @click="setLang(item)"
                        class="btn btn-sm text-uppercase"
                        :class="{ 'btn-primary': item === lang, 'border-danger': !data[lang] && item !== lang }">
                        {{ item }}
                    </button>
                </div>
                <quill-editor :id="id" :class="inputClass" v-model="data[lang]" @input="update" />
            </div>
        </div>
    </div>
    <div v-else>
        <div class="d-flex justify-content-between">
            <label v-if="title" :for="id" class="mb-0 mt-2">{{ title }}</label>
            <div class="form-group mb-0" v-else>
                <label :for="id" class="mb-0 mt-2">
                    <slot name="label"/>
                </label>
            </div>
            <div class="btn-group">
                <button
                    type="button"
                    v-for="(item, i) of langs"
                    :key="i"
                    @click="setLang(item)"
                    class="btn btn-sm text-uppercase"
                    :class="{ 'btn-primary': item === lang, 'border-danger': !data[lang] && item !== lang }">
                    {{ item }}
                </button>
            </div>
        </div>
        <quill-editor
            :id="id"
            :class="inputClass"
            v-model="data[lang]"
            :options="editorOption"
            @input="update"/>
    </div>
</template>

<script>
export default {
    name: 'AppMultiLangQuill',
    props: ['title', 'id', 'value', 'placeholderPrefix', 'inputClass', 'layout', 'langs', 'noCustomBg'],
    data() {
        return {
            lang: this.$i18n.locale || 'en',
            editorOption: {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote', 'link'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        [{ size: ['small', false, 'large', 'huge'] }],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ color: [] }, { background: [] }],
                        [{ align: [] }]
                    ]
                }
            }
        };
    },
    computed: {
        data: {
            get() {
                if (this.value && typeof this.value === 'object' && this.value.constructor === Object) {
                    return this.value;
                }

                return {};
            }
        },
        placeholder() {
            const placeholder = this.placeholderPrefix || '';

            return this.$t(`${placeholder}`);
        }
    },
    methods: {
        update() {
            this.$emit('input', this.data);
        },
        setLang(lang) {
            this.lang = lang;
        }
    }
};
</script>
